import AppActivityIndicator from "@toothfairy/shared-ui/AppActivityIndicator";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppTable from "@toothfairy/shared-ui/AppTable";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, useWindowDimensions } from "react-native";
import ToothFairyModal from "../../../Components/ToothFairyComponents/ToothFairyModal";
import ToothFairySwitch from "../../../Components/ToothFairyComponents/ToothFairySwitch";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import { isLargeScreen } from "../../MainViewContainer";
import FeedbackView from "./SubComponents/FeedbackView";
import { showSideMenu } from "../../../../App";

const HumanFeedbackView = ({
  getFeedbackInProgress,
  displayedFeedback,
  setDisplayedfeedback,
  setLastForwardToken,
  setShowFeedbackModal,
  showFeedbackModal,
  setSelectedIndex,
  selectedIndex,
  rawFeedback,
  handleFeedbackUpdate,
  isFeedbackUpdateInProgress,
  setIsFeedbackUpdateInProgress,
  setIncludeResolved,
  includeResolved,
  members,
  mainFeedbackType,
}) => {
  const { t } = useTranslation();
  const { getLastTabSelectedByScreen } = useWorkspaces();
  const { currentTheme } = AppTheme.useTheme();
  const { width } = useWindowDimensions();

  const columns = [
    {
      title: t("admin.humanFeedback.id"),
      width: 0.2,
    },
    {
      title: t("admin.humanFeedback.type"),
      width: 0.2,
    },
    {
      title: t("admin.humanFeedback.message"),
      width: 0.4,
    },
    {
      title: t("admin.humanFeedback.datetime"),
      width: 0.2,
    },
    {
      title: t("admin.humanFeedback.resolved"),
      width: 0.1,
    },
    {
      title: t("admin.humanFeedback.actions"),
      isAction: true,
      width: 0.00001,
    },
  ];

  const handleFeedbackView = (item, index) => {
    const resolvedIndex = displayedFeedback?.findIndex(
      (feedback) => feedback?.ID === item?.ID,
    );
    setSelectedIndex(resolvedIndex >= 0 ? resolvedIndex : index);
    setShowFeedbackModal(true);
  };

  return (
    <View
      style={{
        width: isLargeScreen() ? "100%" : "100%",
        paddingHorizontal: 10,
      }}
    >
      {getFeedbackInProgress ? (
        <AppActivityIndicator
          backgroundColor={currentTheme?.theme?.softBackgroundColor}
          visible={true}
          containerStyle={{
            backgroundColor: currentTheme?.theme?.transparent,
            minHeight: 250,
          }}
        />
      ) : (
        <>
          {displayedFeedback?.length > 0 ? (
            <View>
              <AppTable
                hideSearch={false}
                showPagination
                searchPlaceholder={t(
                  "common.filterByAnyField",
                  "Filter by any field...",
                )}
                actionButtons
                showDropDownMenuForActions
                mainActionLabel={t("common.view", "View")}
                onClickMainAction={(item, index) => {
                  handleFeedbackView(item, index);
                }}
                onActionItemPress={(id, item, index) => {
                  if (id === "VIEW") {
                    handleFeedbackView(item, index);
                  }
                }}
                actions={[
                  {
                    label: t("common.view", "View"),
                    id: "VIEW",
                    icon: AppAssets.icons.eye,
                  },
                ]}
                style={{ zIndex: -1, marginTop: 15 }}
                headers={columns}
                items={displayedFeedback}
                itemsPerPage={50}
              >
                <ToothFairySwitch
                  wrapperStyle={{
                    maxWidth: 280,
                    width: "auto",
                  }}
                  label={t("admin.humanFeedback.showResolved")}
                  onChange={(v) => {
                    setIncludeResolved(v);
                  }}
                  isTicked={includeResolved}
                />
              </AppTable>
            </View>
          ) : (
            <AppPlaceholderView
              wrapperStyle={{
                height: "auto",
                paddingBottom: 20,
                width: 350,
                marginHorizontal: "auto",
                marginTop: 50,
              }}
              size={30}
              color={currentTheme?.theme?.primary}
              icon={AppAssets?.icons?.feedback}
              mainCaption={t("admin.humanFeedback.noFeedbackFound")}
              subCaption={t("admin.humanFeedback.noFeedbackFoundSub")}
              mainCaptionStyle={
                {
                  // fontSize: currentTheme?.theme?.large_font_size,
                }
              }
            />
          )}
        </>
      )}
      <ToothFairyModal
        key={selectedIndex}
        modalStyle={{
          maxHeight: isLargeScreen() ? 630 : 500,
          height: "95%",
          maxWidth: isLargeScreen() ? 700 : 350,
          marginHorizontal: "auto",
          marginTop: "auto",
          marginBottom: "auto",
          margin: "auto",
        }}
        isModalOpen={showFeedbackModal}
        setIsModalOpen={setShowFeedbackModal}
        modalTitle={t("admin.humanFeedback.feedbackDetails")}
        closeModal={() => {
          setShowFeedbackModal(false);
          setSelectedIndex(null);
        }}
      >
        <FeedbackView
          isFeedbackUpdateInProgress={isFeedbackUpdateInProgress}
          setIsFeedbackUpdateInProgress={setIsFeedbackUpdateInProgress}
          handleFeedbackUpdate={handleFeedbackUpdate}
          members={members}
          feedback={rawFeedback?.find(
            (u) => u?.id === displayedFeedback[selectedIndex]?.ID,
          )}
          isChat={mainFeedbackType === "conversationalFeedback"}
        />
      </ToothFairyModal>
    </View>
  );
};

export default HumanFeedbackView;
